<div *ngIf="single.length > 0 && colorsCharged && general" class="hidden xl:block">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.7, height]"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme"
  >
  </ngx-charts-bar-vertical>
</div>
<div *ngIf="single.length > 0 && colorsCharged && general" class="hidden md:block xl:hidden">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.98, height]"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme"
  >
  </ngx-charts-bar-vertical>
</div>
<div *ngIf="single.length > 0 && colorsCharged && general" class="block md:hidden">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.95, height]"
    [results]="single1"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme1"
  >
  </ngx-charts-bar-vertical>
</div>
<div *ngIf="single.length > 0 && colorsCharged && affiliation" class="hidden xl:block">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.8, height]"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme"
  >
  </ngx-charts-bar-vertical>
</div>
<div *ngIf="single.length > 0 && colorsCharged && affiliation" class="hidden md:block xl:hidden">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.9, height]"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme"
  >
  </ngx-charts-bar-vertical>
</div>
<div *ngIf="single.length > 0 && colorsCharged && affiliation" class="block md:hidden">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.98, height]"
    [results]="single1"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme1"
  >
  </ngx-charts-bar-vertical>
</div>

<div *ngIf="single.length > 0 && colorsCharged && topic" class="hidden xl:block">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.77, height]"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme"
  >
  </ngx-charts-bar-vertical>
</div>
<div *ngIf="single.length > 0 && colorsCharged && topic" class="hidden md:block xl:hidden">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.82, height]"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme"
  >
  </ngx-charts-bar-vertical>
</div>
<div *ngIf="single.length > 0 && colorsCharged && topic" class="block md:hidden">
  <ngx-charts-bar-vertical
    [view]="[window.innerWidth * 0.98, height]"
    [results]="single1"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
    [scheme]="colorScheme1"
  >
  </ngx-charts-bar-vertical>
</div>
